module.exports = __webpack_public_path__ + "img/product-detail-promo-bg.2d59b03.jpg";